import React from 'react';

const Content13W: React.FC = () => {
  return (
    <div className="!space-y-5 !text-sm">
      {/* ĐIỀU I */}
      <div className="pdf-block">
        <h4 className="!font-bold !text-gray-900 dark:!text-white !mb-2">ĐIỀU I: ĐỊNH NGHĨA</h4>
        <div className="!text-gray-700 dark:!text-gray-300 !space-y-2 !pl-4">
          <p>
            <strong>1.</strong> Dự án chương trình 13 tuần thử thách (13W challenge) nằm trong dự án LUMIR: là nền tảng huấn luyện hành vi giao dịch được phát triển và vận hành độc lập trong hệ sinh thái BEQ Holdings; hoạt động trong lĩnh vực đào tạo, huấn luyện và cung cấp phần mềm tự động hóa giao dịch. Dự án này không ảnh hưởng đến hoạt động kinh doanh khác của Công ty, không làm thay đổi quyền và lợi ích hợp pháp của cổ đông hiện tại hoặc tương lai.
          </p>
          <p><strong>2.</strong> Quy mô dự án: Tối đa 68 đối tác.</p>
          <p><strong>3.</strong> Giá trị tham gia: 13.000.000 VND/đối tác (đã bao gồm 10% VAT)</p>
          <p>
            <strong>4.</strong> Doanh thu ròng: là doanh thu gộp phát sinh từ các hoạt động đào tạo, cấp quyền sử dụng phần mềm huấn luyện giao dịch tự động và các dịch vụ liên quan trực tiếp đến chương trình 13 tuần thử thách (13W challenge) nằm trong dự án LUMIR sau khi đã trừ đi các khoản chi phí liên quan và các khoản giảm trừ như: chiết khấu hàng bán, giảm giá hàng bán, thuế và các khoản khấu trừ khác.
          </p>
          <p>
            <strong>5.</strong> Quỹ chia sẻ: 5% trên tổng doanh thu ròng trong kỳ để phân bổ cho các đối tác vượt qua chương trình 13 tuần thử thách (13W challenge).
          </p>
          <p><strong>6.</strong> Kỳ chia: Hàng tháng.</p>
        </div>
      </div>

      {/* ĐIỀU II */}
      <div className="pdf-block">
        <h4 className="!font-bold !text-gray-900 dark:!text-white !mb-2">ĐIỀU II: MỤC ĐÍCH & PHẠM VI</h4>
        <div className="!text-gray-700 dark:!text-gray-300 !space-y-2 !pl-4">
          <p>
            <strong>1.</strong> Thiết lập cơ chế quyền lợi cho chương trình 13 tuần thử thách (13W challenge) với tối đa 68 đối tác (Bên B).
          </p>
          <p>
            <strong>2.</strong> Bên B được quyền sử dụng đầy đủ hệ sinh thái LUMIR (nền tảng, công cụ, tài nguyên đào tạo/hỗ trợ) để thực hiện giao dịch và tạo thu nhập cá nhân.
          </p>
        </div>
      </div>

      {/* ĐIỀU III */}
      <div className="pdf-block">
        <h4 className="!font-bold !text-gray-900 dark:!text-white !mb-2">ĐIỀU III: CƠ CHẾ TÀI CHÍNH</h4>
        <div className="!text-gray-700 dark:!text-gray-300 !space-y-2 !pl-4">
          <p>
            <strong>1.</strong> Chia lại 20%: Bên B đồng ý chia lại cho Bên A 20% trên tổng thu nhập của cá nhân phát sinh từ hoạt động giao dịch sử dụng hệ sinh thái LUMIR trong thời hạn hợp tác.
          </p>
          <p>
            <strong>2.</strong> Nguồn quỹ: Bên A trích 5% trên tổng doanh thu ròng của dự án trong kỳ để hình thành tổng nguồn quỹ.
          </p>
          <p>
            <strong>3.</strong> Sử dụng nguồn quỹ: Nguồn quỹ dùng để chi trả cho các đối tác đang ở trạng thái hiệu lực theo quy định tại Khoản 4 Điều III hợp đồng này.
          </p>
          <p><strong>4.</strong> Nguyên tắc phân bổ:</p>
          <div className="!pl-4 !space-y-1">
            <p>a) Tổng nguồn quỹ được chia đều cho tổng số đối tác đang ở trạng thái hiệu lực tại ngày chốt kỳ.</p>
            <p>b) Khi đủ 68 đối tác, mỗi đối tác nhận 5%/68 ≈ 0,0735294117%/kỳ.</p>
            <p>c) Nếu số đối tác hiệu lực thực tế là N &lt; 68, thì tỉ lệ phần trăm mỗi đối tác nhận được là 5%/N.</p>
          </div>
          <p>
            <strong>5.</strong> Dòng tiền độc lập: Khoản 20% Bên B chia lại từ thu nhập cá nhân cho Bên A và nguồn quỹ trích từ 5% trên tổng doanh thu ròng là hai dòng tiền riêng, không bù trừ (trừ khi có quy định khác tại Khoản 4 Điều IV của hợp đồng này).
          </p>
          <p>
            <strong>6.</strong> Thuế/khấu trừ: Các khoản chi trả được khấu trừ thuế, phí (nếu có) theo quy định; nghĩa vụ thuế thu nhập của mỗi bên thực hiện theo pháp luật nơi cư trú/hoạt động.
          </p>
        </div>
      </div>

      {/* ĐIỀU IV */}
      <div className="pdf-block">
        <h4 className="!font-bold !text-gray-900 dark:!text-white !mb-2">ĐIỀU IV: KỲ CHỐT – ĐỐI SOÁT – CHI TRẢ</h4>
        <div className="!text-gray-700 dark:!text-gray-300 !space-y-2 !pl-4">
          <p><strong>1.</strong> Kỳ chốt: Vào ngày cuối cùng của tháng.</p>
          <p>
            <strong>2.</strong> Báo cáo: Bên A cung cấp báo cáo doanh thu ròng và danh sách đối tác hiệu lực tại ngày chốt; Bên B cung cấp số liệu thu nhập giao dịch (nếu cần kiểm chứng) theo biểu mẫu.
          </p>
          <p>
            <strong>3.</strong> Chi trả tiền quỹ: Bên A thực hiện chi trả tiền quỹ cho Bên B trong vòng 15 ngày làm việc kể từ ngày chốt kỳ, Bên B nộp 20% chia lại từ thu nhập của cá nhân cho Bên A chậm nhất vào ngày 20 hàng tháng.
          </p>
          <p><strong>4.</strong> Điều chỉnh/bù trừ (nếu có):</p>
          <div className="!pl-4 !space-y-1">
            <p>- Trường hợp phát sinh sai số làm thay đổi doanh thu ròng hoặc nguồn quỹ kỳ trước thì phần chênh lệch sẽ điều chỉnh vào kỳ kế tiếp.</p>
            <p>- Trường hợp hai bên có thoả thuận tạm ứng/quy đổi quyền lợi khác thì hai Bên sẽ thống nhất và tiến hành ký kết phụ lục hợp đồng.</p>
          </div>
        </div>
      </div>

      {/* ĐIỀU V */}
      <div className="pdf-block">
        <h4 className="!font-bold !text-gray-900 dark:!text-white !mb-2">ĐIỀU V: QUYỀN, TRÁCH NHIỆM VÀ NGHĨA VỤ CỦA CÁC BÊN</h4>
        <div className="!text-gray-700 dark:!text-gray-300 !space-y-2 !pl-4">
          <p><strong>1. Quyền, trách nhiệm và nghĩa vụ của Bên A:</strong></p>
          <div className="!pl-4 !space-y-1">
            <p>- Toàn quyền quản lý/vận hành Dự án.</p>
            <p>- Bên A có trách nhiệm phát hành hóa đơn giá trị gia tăng (GTGT) hợp pháp tương ứng với giá trị Bên B thanh toán.</p>
            <p>- Không quảng cáo hoặc cam kết lợi nhuận, lãi suất, hay giá trị đầu tư từ việc sở hữu hệ sinh thái LUMIR.</p>
            <p>- Cung cấp hướng dẫn kỹ thuật, hỗ trợ Bên B kích hoạt quyền truy cập.</p>
            <p>- Chi trả tiền quỹ cho Bên B đầy đủ và đúng thời hạn theo Khoản 3 Điều IV của hợp đồng này.</p>
            <p>- Bên A có quyền tạm dừng chi trả và/hoặc chấm dứt quyền lợi nếu phát hiện dấu hiệu gian lận, rửa tiền, thao túng hoặc vi phạm pháp luật/quy định nội bộ; các khoản đã chi (nếu có) có thể bị thu hồi theo quy định.</p>
            <p>- Bên A không chịu trách nhiệm đối với các rủi ro kỹ thuật phát sinh (ví dụ: lỗi mạng, hack, mất ví...).</p>
            <p>- Bên A không bảo đảm giá trị quy đổi, giá bán lại hoặc thanh khoản.</p>
            <p>- Các khoản chi trả cho Bên B được hiểu là thu nhập chịu thuế; Bên A thực hiện tạm khấu trừ và kê khai theo quy định hiện hành.</p>
          </div>

          <p className="!mt-4"><strong>2. Quyền, trách nhiệm và nghĩa vụ của Bên B:</strong></p>
          <div className="!pl-4 !space-y-1">
            <p>- Thanh toán đầy đủ, đúng thời hạn quy định theo Khoản 3 Điều IV của hợp đồng này.</p>
            <p>- Sử dụng hệ sinh thái LUMIR đúng mục đích, không được dùng hệ sinh thái LUMIR để huy động vốn, đầu tư tài chính hoặc đầu cơ sinh lời.</p>
            <p>- Không sao chép, chia sẻ, hoặc sử dụng hệ sinh thái LUMIR vượt quá phạm vi được cấp.</p>
            <p>- Nộp các khoản thuế phát sinh (nếu có) theo quy định.</p>
            <p>- Đảm bảo tối thiểu 30% thời lượng tham gia lớp huấn luyện, tương đương 27 buổi (kể cả offline và online).</p>
            <p>- Có thái độ tích cực tham gia các buổi huấn luyện.</p>
            <p>- Được quyền bảo lưu tối đa ba (03) lần trong suốt thời gian huấn luyện.</p>
            <p>- Tuân thủ Điều khoản sử dụng dịch vụ do Bên A ban hành.</p>
          </div>
        </div>
      </div>

      {/* ĐIỀU VI */}
      <div className="pdf-block">
        <h4 className="!font-bold !text-gray-900 dark:!text-white !mb-2">ĐIỀU VI: ĐIỀU KHOẢN CHUYỂN NHƯỢNG</h4>
        <div className="!text-gray-700 dark:!text-gray-300 !space-y-2 !pl-4">
          <p><strong>1.</strong> Bên B được quyền chuyển nhượng, tặng cho hoặc sang nhượng phần quyền lợi hợp tác cho bên thứ ba khác, với điều kiện:</p>
          <div className="!pl-4 !space-y-1">
            <p>- Có sự chấp thuận bằng văn bản của Bên A;</p>
            <p>- Bên nhận chuyển nhượng đáp ứng đủ điều kiện hợp tác theo quy định của Bên A (tư cách pháp lý, năng lực tài chính, tuân thủ pháp luật).</p>
          </div>
          <p><strong>2.</strong> Bên A có quyền thu phí xử lý hồ sơ chuyển nhượng (nếu có).</p>
          <p><strong>3.</strong> Sau khi hoàn tất chuyển nhượng, mọi quyền và nghĩa vụ của Bên B sẽ được chuyển giao cho bên nhận chuyển nhượng và chấm dứt quyền của Bên B cũ.</p>
          <p><strong>4.</strong> Việc chuyển nhượng không làm ảnh hưởng đến cơ chế tài chính của Dự án.</p>
        </div>
      </div>

      {/* ĐIỀU VII */}
      <div className="pdf-block">
        <h4 className="!font-bold !text-gray-900 dark:!text-white !mb-2">ĐIỀU VII: GIỚI HẠN & THAY ĐỔI QUY MÔ</h4>
        <div className="!text-gray-700 dark:!text-gray-300 !space-y-2 !pl-4">
          <p><strong>1.</strong> Số lượng tối đa 68 đối tác; Bên A có quyền mở khóa theo đợt, danh sách hiệu lực công bố tại ngày chốt kỳ.</p>
          <p><strong>2.</strong> Nếu số lượng đối tác thay đổi theo từng thời điểm, tỷ lệ nhận tiền quỹ của mỗi đối tác sẽ tự động cập nhật theo công thức 5%/N tại kỳ tương ứng (N là số lượng đối tác tại thời điểm chốt).</p>
        </div>
      </div>

      {/* ĐIỀU VIII */}
      <div className="pdf-block">
        <h4 className="!font-bold !text-gray-900 dark:!text-white !mb-2">ĐIỀU VIII: BẢO MẬT - BẤT KHẢ KHÁNG - TRANH CHẤP</h4>
        <div className="!text-gray-700 dark:!text-gray-300 !space-y-2 !pl-4">
          <p><strong>1. Bảo mật:</strong></p>
          <div className="!pl-4 !space-y-1">
            <p>- Hai bên cam kết bảo mật toàn bộ thông tin giao dịch, dữ liệu khách hàng;</p>
            <p>- Mọi dữ liệu, thuật toán, mô hình, và chiến lược của Dự án LUMIR thuộc sở hữu độc quyền của Bên A. Bên B không được sao chép, chuyển giao hoặc sử dụng cho mục đích thương mại khác. Vi phạm quy định này sẽ bị phạt tối thiểu 200% giá trị khoản đầu tư;</p>
          </div>

          <p className="!mt-4"><strong>2. Sự kiện bất khả kháng:</strong></p>
          <div className="!pl-4 !space-y-1">
            <p>- Sự Kiện Bất Khả Kháng là sự kiện xảy ra một cách khách quan không thể lường trước được và vượt quá sự kiểm soát hợp lý của một Bên làm cho Bên đó không thể tuân thủ hoặc thực hiện đúng thời hạn một nghĩa vụ quy định trong Hợp đồng này. Các Sự Kiện Bất Khả Kháng bao gồm: thiên tai (gồm bão lụt, động đất, sóng thần hay các thảm họa tự nhiên khác), hỏa hoạn, địch họa, bạo loạn, dịch bệnh, chiến tranh, nội chiến, nổi loạn, khủng bố, bạo loạn, Luật Việt Nam có sự điều chỉnh/thay đổi, quyết định/hành vi của cơ quan Nhà nước có thẩm quyền, sự ngưng trệ trong xử lý công việc của cơ quan Nhà nước có thẩm quyền, sự thay đổi chính sách, pháp luật, chủ trương của cơ quan Nhà nước có thẩm quyền....</p>
            <p>- Nếu một Bên bị ngăn cản, cản trở hoặc trì hoãn thực hiện bất kỳ nghĩa vụ nào của mình theo Hợp đồng do một Sự Kiện Bất Khả Kháng thì các nghĩa vụ của Bên đó được tạm đình chỉ trong thời gian Sự Kiện Bất Khả Kháng tiếp diễn trong phạm vi Bên đó bị ngăn cản, cản trở hoặc chậm trễ. Việc chậm thực hiện hoặc không thực hiện được bất kỳ nghĩa vụ/cam kết theo Hợp đồng này do Sự Kiện Bất Khả Kháng không bị coi là vi phạm Hợp đồng này.</p>
            <p>- Bên gặp phải Sự Kiện Bất Khả Kháng phải thông báo ngay và kịp thời cho Bên còn lại về trường hợp bất khả kháng xảy ra tối đa trong vòng 05 Ngày Làm Việc kể từ thời điểm Sự Kiện Bất Khả Kháng xảy ra để Các Bên cùng tìm cách giải quyết.</p>
          </div>

          <p className="!mt-4"><strong>3. Giải quyết tranh chấp:</strong></p>
          <div className="!pl-4 !space-y-1">
            <p>- Tranh chấp phát sinh từ hợp đồng này được ưu tiên giải quyết bằng thương lượng, hòa giải.</p>
            <p>- Nếu không đạt thỏa thuận, tranh chấp được giải quyết tại Tòa án nhân dân có thẩm quyền tại Thành phố Hồ Chí Minh.</p>
            <p>- Hợp đồng này chịu sự điều chỉnh của pháp luật Việt Nam.</p>
          </div>
        </div>
      </div>

      {/* ĐIỀU IX */}
      <div className="pdf-block">
        <h4 className="!font-bold !text-gray-900 dark:!text-white !mb-2">ĐIỀU IX: ĐIỀU KHOẢN CHUNG</h4>
        <div className="!text-gray-700 dark:!text-gray-300 !space-y-2 !pl-4">
          <p><strong>1.</strong> Hợp đồng này có hiệu lực từ ngày ký;</p>
          <p><strong>2.</strong> Hợp đồng này được lập hai (02) bản, mỗi Bên giữ một (01) bản, có giá trị pháp lý như nhau;</p>
          <p><strong>3.</strong> Các phụ lục (nếu có) là một phần không tách rời của Hợp đồng hợp tác này.</p>
        </div>
      </div>
    </div>
  );
};

export default Content13W;
